import {Component, Inject, PLATFORM_ID} from '@angular/core';
import {ApiHandlerService} from "../../core/services/apiCall.service";
import {AuthService} from "../../core/services/auth.service";
import {Router} from "@angular/router";
import {AsyncPipe, isPlatformBrowser, NgForOf, NgIf} from "@angular/common";
import {catchError, map, tap, finalize} from 'rxjs/operators';
import {BehaviorSubject, of} from 'rxjs';
import {LoadingComponent} from "../../shared/loading/loading.component";
import {DeviceListComponent} from "../../shared/device-list/device-list.component";

@Component({
    selector: 'app-devices-page',
    standalone: true,
    imports: [
        AsyncPipe,
        LoadingComponent,
        NgIf,
        NgForOf,
        DeviceListComponent
    ],
    templateUrl: './devices-page.component.html',
    styleUrls: ['./devices-page.component.scss']
})
export class DevicesPageComponent {
    protected devicesList: any[] = [];
}
